import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function WithIcon ({
  icon,
  placement = 'left',
  className,
  color = 'current',
  size = 4,
  space = 'space-x-2',
  children
}) {
  const withIconClassNames = classNames(
    className,
    'with-icon inline-flex items-center',
    space
  )

  const iconClassNames = classNames(
    'fill-current',
    { 'w-2 h-2': size === 2 },
    { 'w-3 h-3': size === 3 },
    { 'w-4 h-4': size === 4 },
    { 'w-5 h-5': size === 5 },
    { 'w-6 h-6': size === 6 },
    { 'w-8 h-8': size === 8 },
    { 'w-10 h-10': size === 10 }
  )

  const iconElement = React.cloneElement(icon, {
    className: classNames(iconClassNames)
  })

  const childrenJSX = <span className='inline-flex items-center'>{children}</span>

  return (
    <div className={withIconClassNames}>
      {placement === 'left' ? (
        <>
          {iconElement}
          {childrenJSX}
        </>
      ) : (
        <>
          {childrenJSX}
          {iconElement}
        </>
      )}
    </div>
  )
}

WithIcon.propTypes = {
  placement: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  icon: PropTypes.node,
  boxed: PropTypes.bool,
  withFullWidth: PropTypes.bool,
  onClick: PropTypes.func
}

export default WithIcon
